export const AUTH_PREFIX = 'Bearer ';
export interface domainType {
  homeDigit: string;
}

/**
 * 首页大屏域名映射
 */
export const DOMAIN_MAP: Record<string, domainType> = {
  'localhost:3000': {
    homeDigit: 'localhost:8000',
  },
  'exmt-dev1.microconnect.cc': {
    homeDigit: 'exmt-dev1.microconnect.cc',
  },
  'exmt-dev2.microconnect.cc': {
    homeDigit: 'exmt-dev1.microconnect.cc',
  },
  'mtex-stg2.microconnect.cc': {
    homeDigit: 'stg4.mcisaas.com',
  },
  'exmt-uat1.microconnect.cc': {
    homeDigit: 'stg4.mcisaas.com',
  },
  'mt.microconnect.cc': {
    homeDigit: 'mcex.microconnect.cc',
  },
  // 新域名
  'exmt-stg1.microconnect.cc': {
    homeDigit: 'stg4.mcisaas.com',
  },
  'exmt-stg2.microconnect.cc': {
    homeDigit: 'exmt-stg2.microconnect.cc',
  },
};

/**
 * 会员中心域名映射
 */
export const MEMBER_DOMAIN_MAP: Record<string, domainType> = {
  'localhost:3000': {
    homeDigit: 'localhost:3001',
  },
  'exmt-dev1.microconnect.cc': {
    homeDigit: 'exmbr-dev1.microconnect.cc',
  },
  'exmt-dev2.microconnect.cc': {
    homeDigit: 'exmbr-dev1.microconnect.cc',
  },
  'mtex-stg2.microconnect.cc': {
    homeDigit: 'mtex-stg1.microconnect.cc',
  },
  'exmt-uat1.microconnect.cc': {
    homeDigit: 'exmbr-uat1.microconnect.cc',
  },
  'mt.microconnect.cc': {
    homeDigit: 'member.mcex.mo',
  },
  // 新域名
  'exmt-stg1.microconnect.cc': {
    homeDigit: 'exmbr-stg1.microconnect.cc',
  },
  'exmt-stg2.microconnect.cc': {
    homeDigit: 'exmbr-stg2.microconnect.cc',
  },
};

/**
 * h5域名映射
 */
export const H5_DOMAIN_MAP: Record<string, domainType> = {
  'localhost:3000': {
    homeDigit: 'dev2-mtmobile.microconnect.cc',
  },
  'exmt-dev1.microconnect.cc': {
    homeDigit: 'dev2-mtmobile.microconnect.cc',
  },
  'mtex-stg2.microconnect.cc': {
    homeDigit: 'stg2-mtmobile.microconnect.cc',
  },
  'exmt-uat1.microconnect.cc': {
    homeDigit: 'uat1-mtmobile.microconnect.cc',
  },
  'mt.microconnect.cc': {
    homeDigit: 'mtmobile.microconnect.cc',
  },
  // 新域名
  'exmt-stg1.microconnect.cc': {
    homeDigit: 'stg2-mtmobile.microconnect.cc',
  },
};

export const DefaultMetfCode = 'ETF.001';
